const LOCAL_API_BASE_URL = 'http://localhost:5000/api';

const isLocalHostname = (hostname: string) =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';

const getDefaultApiBaseUrl = () => {
  if (typeof window === 'undefined') {
    return LOCAL_API_BASE_URL;
  }

  return isLocalHostname(window.location.hostname)
    ? LOCAL_API_BASE_URL
    : `${window.location.origin}/api`;
};

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || getDefaultApiBaseUrl();
